exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CZ1td {\n  margin: 0 auto;\n  max-width: var(--max-content-width);\n  overflow: hidden;\n}", ""]);

// exports
exports.locals = {
	"container": "CZ1td"
};